import {MrSubscriptionQuoteResponse} from '@peachy/core-domain-pure'
import {Draft} from '@peachy/utility-kit-pure'
import {createSignal, mergeProps, ParentComponent, Show} from 'solid-js'
import {IStore} from '../../global/storage/IStore'
import {SubscriptionQuoteRepository} from '../../service/subscription/SubscriptionQuoteRepository'
import {useSubscriptionService} from '../AppServiceProvider'
import {AccountSubscriptionStore} from './stores/AccountSubscriptionStore'
import {usePlanConfig} from '../../config/configureApp'

interface Props {
    store: IStore<Draft<MrSubscriptionQuoteResponse>>
    saveToServer?: boolean
}

const [store, setStore] = createSignal<AccountSubscriptionStore>()

// TODO: rename as no longer a Provider but just a component
export const AccountSubscriptionProvider: ParentComponent<Props> = (propsIn) => {

    const props = mergeProps({saveToServer: false}, propsIn)

    const subscriptionService = props.saveToServer ? useSubscriptionService() : undefined

    setStore(new AccountSubscriptionStore(new SubscriptionQuoteRepository(props.store, subscriptionService), usePlanConfig()))

    return (
        <Show when={store()}>
            {props.children}
        </Show>
    )
}

export const useStore = () => store()
